'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIBox;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _FlexConstants = require('./FlexConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getFlexBasis = function getFlexBasis(basis) {
  return {
    msFlexPreferredSize: basis,
    WebkitFlexBasis: basis,
    flexBasis: basis
  };
};

var getFlexGrow = function getFlexGrow(grow) {
  return {
    msFlexPositive: grow,
    WebkitFlexGrow: grow,
    flexGrow: grow
  };
};

var getFlexShrink = function getFlexShrink(shrink) {
  return {
    msFlexNegative: shrink,
    WebkitFlexShrink: shrink,
    flexShrink: shrink
  };
};

var getOrder = function getOrder(order) {
  return {
    msFlexOrder: order,
    WebkitOrder: order,
    order: order
  };
};

var getClassName = function getClassName(_ref) {
  var alignSelf = _ref.alignSelf,
      className = _ref.className;

  return (0, _reactUtils.classNames)('private-flex__child', className, _FlexConstants.ALIGN_SELF_CLASSES[alignSelf]);
};

function UIBox(_ref2) {
  var alignSelf = _ref2.alignSelf,
      basis = _ref2.basis,
      children = _ref2.children,
      className = _ref2.className,
      grow = _ref2.grow,
      order = _ref2.order,
      shrink = _ref2.shrink,
      style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ['alignSelf', 'basis', 'children', 'className', 'grow', 'order', 'shrink', 'style']);

  return _react2.default.createElement(
    'div',
    _extends({}, props, {
      className: getClassName({ alignSelf: alignSelf, className: className }),
      style: _extends({}, getFlexGrow(grow), getFlexShrink(shrink), getFlexBasis(basis), getOrder(order), style)
    }),
    children
  );
}

UIBox.defaultProps = {
  alignSelf: 'auto',
  basis: 'auto',
  grow: 0,
  order: 0,
  shrink: 1
};

UIBox.propTypes = {
  alignSelf: _react.PropTypes.oneOf(Object.keys(_FlexConstants.ALIGN_SELF_CLASSES)),
  basis: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  grow: _react.PropTypes.number,
  order: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['inherit', 'initial', 'unset'])]),
  shrink: _react.PropTypes.number,
  style: _react.PropTypes.object
};

UIBox.displayName = 'UIBox';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/layout/UIBox.js
// module id = 250
// module chunks = 0 1